function getTbTeamFromUrlOrStorage() {
  const params = new URLSearchParams(window.location.search);
  let tbteam = params.get("tbteam");

  if (tbteam) {
    tbteam = tbteam.trim();
    if (tbteam) {
      window.localStorage.setItem("tbteam", tbteam);
      return tbteam;
    }
  }

  const stored = window.localStorage.getItem("tbteam");
  return stored ? stored.trim() : null;
}

function identifyTeddyTeamForEmail(email) {
  const tbteam = getTbTeamFromUrlOrStorage();
  if (!tbteam || !email) return;

  window._learnq = window._learnq || [];
  window._learnq.push([
    "identify",
    {
      email: email,
      "Teddy Team": tbteam,
    },
  ]);
}

class MarketingHero extends HTMLElement {
  constructor() {
    super();
    this.handleSubmit = this.handleFormSubmit.bind(this);
    this.emailSource = this.dataset.emailSource;
    this.smsSource = this.dataset.smsSource;
  }

  connectedCallback() {
    this.addEventListener("submit", this.handleSubmit);
  }

  disconnectedCallback() {
    this.removeEventListener("submit", this.handleSubmit);
  }

  async handleFormSubmit(e) {
    e.preventDefault();

    const form = e.target;
    const signupModal = document.querySelector("multi-step-signup");

    if (!signupModal) return;

    const emailEl = form.querySelector('[type="email"]');
    const phoneEl = form.querySelector('[type="tel"]');

    if (emailEl) {
      const signupEmail = signupModal.querySelector('[type="email"]');
      if (signupEmail) {
        signupEmail.value = emailEl.value;
      }

      identifyTeddyTeamForEmail(emailEl.value);
    }

    if (phoneEl) {
      const inputIntl = this.querySelector("input-tel-intl");
      const signupIntl = signupModal.querySelector("input-tel-intl");

      if (inputIntl && signupIntl && inputIntl.iti) {
        const iti = inputIntl.iti;
        signupIntl.setActiveCountry(iti.s.iso2);
      }

      const signupPhone = signupModal.querySelector('[type="tel"]');
      if (signupPhone) {
        signupPhone.value = phoneEl.value;
      }
    }

    signupModal.emailSource = this.emailSource;
    signupModal.smsSource = this.smsSource;
    signupModal.tbteam = getTbTeamFromUrlOrStorage();
    signupModal.open();
  }
}

customElements.define("marketing-hero", MarketingHero);
